import { RegionState } from "./types";

export function getDefaultState(): RegionState {
	return {
		regions: {},
		allRegions: [],
		logins: {},
		xsrfTokens: {}
	};
}
